






























import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { InfoState } from '../../../core/core.store';

const cssPrefix = 'productGroupSelectDialog';

@Component({
  components:{
    ...UUIFComponent,
    SwSelect,
  },
})
export default class ProductGroupSelectDialog extends SwExtendedVue {

  cssPrefix = cssPrefix;

  @Prop({ default: false })
  showProductGroupSelectDialog: boolean;

  get productGroupOptions() : SelectOption[] {
    const temp : SelectOption[] = [];
    this.productGroupsList &&
    this.productGroupsList.length > 0 &&
    this.productGroupsList.forEach((productGroup: any) => {
      temp.push({
        id: productGroup.productGroupId,
        label: productGroup.productGroupName,
        value: productGroup.productGroupId,
      });
    });
    return temp;
  }

  productGroupsList: any[] = [];
  selectedProductGroup: string = '';

  mounted() {
    this.getTenents();
  }

  getTenents() {
    this.$store.dispatch('CatalogStoreModule/getProductGroup')
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.productGroupsList = response.hasOwnProperty('productGroup') ? response.productGroup : [];
          this.selectedProductGroup = this.productGroupsList.find(item => item.isDefaultGroup === 'TRUE').productGroupId;
          if (this.selectedProductGroup === undefined || this.selectedProductGroup === null) {
            this.selectedProductGroup = this.productGroupsList  &&
              this.productGroupsList[0] &&
              this.productGroupsList[0].hasOwnProperty('productGroupId') ?
              this.productGroupsList[0].productGroupId : '';
          }
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'high',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }
  closeDialog() {
    this.$emit('close-dialog');
  }
  onChangeProductGroup(value: any) {
    this.selectedProductGroup = value;
  }
  onSelectTenent() {
    const value: any = this.productGroupsList.filter((productGroup:  any) => {
      return productGroup.productGroupId === this.selectedProductGroup;
    })[0] || {};
    this.$emit('close-dialog', value);
  }
  openAddNewTenant() {
  }
}
